import React from 'react';
import { List, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import CustomList from './detail/CustomList';

const SchedulerList = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.list', {
      resource: translate('resources.scheduler.name', { smart_count: 2 }),
    }),
  );
  return (
    <List {...props} perPage={50} component="div">
      <CustomList />
    </List>
  );
};

export default SchedulerList;
